import { Star, Quote } from "lucide-react";

const reviews = [
  { name: "Giulia R.", role: "Liceo scientifico, 17 anni", text: "Prima rileggevo tutto mille volte. Con le 4 fasi ho dimezzato le ore di studio e all'orale finalmente riesco a spiegare con parole mie." },
  { name: "Marco T.", role: "Università, Ingegneria", text: "Gli esercizi guidati sono la parte migliore: applichi subito il metodo ai tuoi appunti e capisci dove ti illudevi di sapere. Consigliatissimo per chi ha esami pesanti." },
  { name: "Sofia B.", role: "Maturità 2025", text: "L'ansia da interrogazione era il mio incubo. Il metodo in 10 minuti mi ha dato una struttura e tanta sicurezza in più." },
  { name: "Luca P.", role: "Università, Giurisprudenza", text: "Non è la solita teoria: gli esercizi guidati li uso davvero sui miei testi. A questo prezzo è un affare." },
  { name: "Elena M.", role: "Istituto tecnico, 19 anni", text: "Finalmente ho capito la differenza tra memorizzare e comprendere. Ora studio con più controllo e meno stress." },
  { name: "Davide C.", role: "Studente lavoratore", text: "Ho poco tempo e questo manuale mi ha insegnato a renderlo produttivo. Download immediato e subito operativo." },
];

export default function Testimonials() {
  return (
    <section id="recensioni" className="relative py-16 sm:py-24 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="text-center max-w-2xl mx-auto">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#5982c5]">Recensioni</span>
          <h2 className="mt-4 font-heading text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#1f2937]">
            Cosa dicono i nostri studenti
          </h2>
          <div className="mt-4 flex items-center justify-center gap-2">
            <div className="flex">
              {[...Array(5)].map((_, i) => <Star key={i} size={20} className="text-[#f0d203] fill-[#f0d203]" />)}
            </div>
            <span className="font-semibold text-[#4b5563]">4,9 / 5 su oltre 1.000 studenti</span>
          </div>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reviews.map((r, i) => (
            <div key={i} className="bg-[#ecfef7] rounded-3xl p-7 border border-[#5982c5]/10 relative">
              <Quote size={36} className="text-[#f0d203] absolute top-6 right-6 opacity-60" />
              <div className="flex gap-1 mb-4">
                {[...Array(5)].map((_, j) => <Star key={j} size={16} className="text-[#f0d203] fill-[#f0d203]" />)}
              </div>
              <p className="text-[#1f2937] leading-relaxed">“{r.text}”</p>
              <div className="mt-6 flex items-center gap-3">
                <div className="w-11 h-11 rounded-full bg-[#5982c5] text-white font-heading font-bold flex items-center justify-center">
                  {r.name.charAt(0)}
                </div>
                <div>
                  <p className="font-heading font-bold text-[#1f2937]">{r.name}</p>
                  <p className="text-sm text-[#9ca3af]">{r.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
